import { render, staticRenderFns } from "./angle.vue?vue&type=template&id=e331d03c&scoped=true"
import script from "./angle.vue?vue&type=script&lang=js"
export * from "./angle.vue?vue&type=script&lang=js"
import style0 from "./angle.vue?vue&type=style&index=0&id=e331d03c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e331d03c",
  null
  
)

export default component.exports